export enum BuyerMarketplaceTab {
    Opportunities = 0,
    DeadlineDocket = 1,
    Profile = 2,
    MyTeamMembers = 3,
    ConnectMarketplaceAgreements = 4,
    ConnectMarketplaceTemplates = 5,
    CurrentProcessCommercialTerms = 6,
}

export const BuyerMarketplacePageTabs = [
    {
        id: BuyerMarketplaceTab.Opportunities,
        name: 'Marketplace Opportunities',
    },
    {
        id: BuyerMarketplaceTab.DeadlineDocket,
        name: 'Marketplace Opportunities',
    },
    {
        id: BuyerMarketplaceTab.Profile,
        name: 'Marketplace Opportunities',
    },
    {
        id: BuyerMarketplaceTab.MyTeamMembers,
        name: 'Marketplace Opportunities',
    },
];
